import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import FormReplyScreen from "./form-reply-screen";
import FormRepliesScreen from "./form-replies-screen";

/**
 * Component for form routes
 */
const FormRoutes: React.FC = () => (
  <Routes>
    <Route
      path="/"
      element={ <Navigate to="./answers"/> }
    />
    <Route
      path="/answers"
      element={ <FormRepliesScreen/> }
    />
    <Route
      path="/answers/:replyId"
      element={ <FormReplyScreen/> }
    />
  </Routes>
);

export default FormRoutes;